import { createTheme } from './baseTheme';
import { colorPalette } from './colors';

export const darkTheme = createTheme({
  colors: {
    black0: colorPalette.black600,
    black100: colorPalette.black500,
    black150: colorPalette.black400,
    black200: colorPalette.black350,
    black300: colorPalette.black300,
    black350: colorPalette.black200,
    black400: colorPalette.black150,
    black500: colorPalette.black100,
    black600: colorPalette.black0,
    blue0: colorPalette.blue700,
    blue100: colorPalette.blue600,
    blue150: colorPalette.blue500,
    blue200: colorPalette.blue400,
    blue300: colorPalette.blue300,
    blue400: colorPalette.blue200,
    blue500: colorPalette.blue150,
    blue600: colorPalette.blue100,
    blue700: colorPalette.blue0,
    green0: colorPalette.green600,
    green100: colorPalette.green500,
    green150: colorPalette.green400,
    green200: colorPalette.green300,
    green300: colorPalette.green200,
    green400: colorPalette.green150,
    green500: colorPalette.green100,
    green600: colorPalette.green0,
    red0: colorPalette.red600,
    red100: colorPalette.red500,
    red150: colorPalette.red400,
    red200: colorPalette.red300,
    red300: colorPalette.red200,
    red400: colorPalette.red150,
    red500: colorPalette.red100,
    red600: colorPalette.red0,
    triumphTeal100: colorPalette.triumphTeal900,
    triumphTeal200: colorPalette.triumphTeal800,
    triumphTeal300: colorPalette.triumphTeal700,
    triumphTeal400: colorPalette.triumphTeal600,
    triumphTeal500: colorPalette.triumphTeal500,
    triumphTeal600: colorPalette.triumphTeal400,
    triumphTeal700: colorPalette.triumphTeal300,
    triumphTeal800: colorPalette.triumphTeal200,
    triumphTeal900: colorPalette.triumphTeal100,
    yellow0: colorPalette.yellow600,
    yellow100: colorPalette.yellow500,
    yellow150: colorPalette.yellow400,
    yellow200: colorPalette.yellow300,
    yellow300: colorPalette.yellow200,
    yellow400: colorPalette.yellow150,
    yellow500: colorPalette.yellow100,
    yellow600: colorPalette.yellow0,
  },
  mode: 'dark',
  semanticColors: {
    /* eslint-disable @typescript-eslint/naming-convention */
    background_product: 'hsl(228, 8%, 12%)',

    border_default: 'var(--color-navy_700)',
    border_disabled: 'var(--color-navy_500)',
    border_focus: 'var(--color-navy_400)',
    border_hover: 'var(--color-navy_200)',
    border_selected: 'var(--color-triumph_teal_300)',

    button_secondary_border: 'var(--color-triumph_teal_500)',
    button_secondary_text_active: 'var(--color-navy_0)',
    button_secondary_text_default: 'var(--color-navy_0)',
    button_secondary_text_disabled: 'var(--color-navy_500)',
    button_secondary_text_hover: 'var(--color-navy_0)',
    button_tertiary_text_default: 'var(--color-triumph_teal_400)',

    calender_day_range_background: 'hsl(225, 9%, 23%)',

    card_background: 'hsl(223, 9%, 15%)',
    card_border: 'hsl(224, 8%, 28%)',

    contact_info_list_item_selected_background: 'hsl(223, 9%, 20%)',

    content_tabs_background: 'var(--color-navy_500)',

    danger_button_secondary_text_active: 'var(--color-navy_0)',
    danger_button_secondary_text_default: 'var(--color-navy_0)',
    danger_button_secondary_text_disabled: 'var(--color-navy_500)',
    danger_button_secondary_text_hover: 'var(--color-navy_0)',
    danger_button_text_active: 'var(--color-navy_0)',

    descriptor_tag_error_background: 'hsl(9 100% 14%)',
    descriptor_tag_error_text: 'var(--color-danger_200)',
    descriptor_tag_info_background: 'var(--color-triumph_teal_900)',
    descriptor_tag_info_text: 'var(--color-triumph_teal_200)',
    descriptor_tag_neutral_background: 'var(--color-navy_900)',
    descriptor_tag_neutral_text: 'var(--color-navy_200)',
    descriptor_tag_success_background: 'hsl(145 100% 8%)',
    descriptor_tag_success_text: 'var(--color-success_200)',
    descriptor_tag_warning_background: 'hsl(25 100% 12%)',
    descriptor_tag_warning_text: 'var(--color-warning_200)',

    disabled_overlay: 'hsl(223, 9%, 15%)',

    divider: 'hsl(224, 8%, 28%)',

    icon_active: 'var(--color-navy_0)',
    icon_danger: 'var(--color-danger_300)',
    icon_default: 'var(--color-navy_0)',
    icon_disabled: 'var(--color-navy_300)',
    icon_info: 'var(--color-triumph_teal_300)',
    icon_neutral: 'var(--color-navy_400)',
    icon_success: 'var(--color-success_300)',
    icon_utility: 'var(--color-navy_100)',
    icon_warning: 'var(--color-warning_300)',
    icon_white: 'var(--color-navy_0)',

    input_background_default: 'hsl(228, 8%, 12%)',
    input_background_disabled: 'var(--color-navy_500)',
    input_border_danger: 'var(--color-danger_400)',
    input_border_default: 'hsl(224, 8%, 28%)',
    input_border_focus_danger: 'var(--color-danger_600)',
    input_border_focus_default: 'var(--color-navy_500)',
    input_placeholder: 'var(--color-navy_300)',

    insights_graph_grid_line: 'var(--color-navy_600)',
    insights_graph_line_primary: 'var(--color-triumph_teal_400)',
    insights_graph_tick_text: 'var(--color-navy_400)',
    insights_legend_text: 'var(--color-navy_300)',

    invoice_status_tracker_active_background: 'hsl(228, 8%, 12%)',

    menu_item_border_bottom: 'hsl(224, 8%, 28%)',
    menu_item_disabled_background: 'var(--color-navy_500)',
    menu_item_disabled_text: 'var(--color-navy_300)',
    menu_item_focus_background: 'hsl(223, 9%, 20%)',
    menu_item_li_hover_background: 'hsl(223, 9%, 25%)',
    menu_item_selected_background: 'var(--color-triumph_teal_600)',
    menu_item_selected_focus_background: 'var(--color-triumph_teal_700)',
    menu_item_text: 'var(--color-navy_0)',

    nav_background: 'hsl(223, 9%, 15%)',
    nav_border: 'hsl(224, 8%, 28%)',
    nav_item_active_background: 'hsl(228, 8%, 40%)',
    nav_item_hover: 'hsl(228, 8%, 20%)',

    notification_danger_background: 'hsl(9 100% 14%)',
    notification_danger_border: 'var(--color-danger_400)',
    notification_info_background: 'var(--color-triumph_teal_900)',
    notification_info_border: 'var(--color-triumph_teal_400)',
    notification_success_background: 'hsl(145 100% 8%)',
    notification_success_border: 'var(--color-success_400)',
    notification_warning_background: 'hsl(25 100% 12%)',
    notification_warning_border: 'var(--color-warning_400)',

    queue_tabs_background: 'hsl(228, 8%, 12%)',

    scrim_overlay: 'hsla(228, 8%, 12%, 0.9)',

    sidenav_background: 'hsl(228, 8%, 12%)',

    skeleton_background: 'hsl(223, 9%, 15%)',
    skeleton_foreground: 'hsl(224, 9%, 12%)',

    status_text_outlined: 'var(--color-navy_0)',

    system_notification_danger: 'var(--color-danger_400)',
    system_notification_warning: 'var(--color-warning_400)',

    table_background: 'hsl(228, 8%, 12%)',
    table_divider: 'hsl(224, 8%, 28%)',
    table_filter_drawer_background: 'hsl(228, 8%, 12%)',
    table_head_hover_background: 'hsl(228, 8%, 10%)',
    table_pinned_column_border: 'hsl(224, 8%, 28%)',
    table_resize_handle: 'var(--color-triumph_teal_200)',
    table_row_even_background: 'hsl(223, 9%, 15%)',
    table_row_odd_background: 'hsl(228, 8%, 12%)',

    text_active: 'var(--color-navy_0)',
    text_branded: 'var(--color-brand_500)',
    text_default: 'var(--color-navy_0)',
    text_disabled: 'var(--color-navy_300)',
    text_error: 'var(--color-red_200)',
    text_light: 'var(--color-navy_0)',
    text_link: 'var(--color-triumph_teal_400)',
    text_success: 'var(--color-success_400)',
    text_warning: 'var(--color-warning_200)',

    utility_button_border_default: 'hsl(224, 8%, 28%)',
    utility_button_border_hover: 'var(--color-triumph_teal_400)',
    utility_button_fill_active: 'hsl(228, 8%, 12%)',
    utility_button_fill_hover: 'hsl(228, 8%, 20%)',
    utility_button_icon_default: 'hsl(224, 8%, 64%)',
    /* eslint-enable @typescript-eslint/naming-convention */
  },
});
